module.exports = __webpack_public_path__ + "5f0f40de9dd95581cc9ddf7bad5256ec.svg";